import {Component, EventEmitter, inject, Input, Output} from '@angular/core';
import {DxTextBoxModule, DxValidatorModule} from 'devextreme-angular';
import notify from 'devextreme/ui/notify';
import {EmployeesClient, IssuePasswordCommand} from '@services';
import {FormPopupComponent} from 'src/app/components/utils/form-popup/form-popup.component';

@Component({
    selector: 'issue-password-popup',
    templateUrl: './issue-password-popup.component.html',
    imports: [
        DxTextBoxModule,
        DxValidatorModule,
        FormPopupComponent
    ]
})
export class IssuePasswordPopupComponent {
    @Input() userId: string;
    @Input() visible = false;
    @Output() visibleChange = new EventEmitter<boolean>();

    private employeesClient = inject(EmployeesClient);

    // Initialised so the first reset() isn't a value change, which would show the required error on open.
    protected password = '';
    protected isSaving = false;

    protected reset() {
        this.password = '';
        this.isSaving = false;
    }

    protected onVisibleChange(visible: boolean) {
        this.visible = visible;
        this.visibleChange.emit(visible);
    }

    protected confirm() {
        this.isSaving = true;
        this.employeesClient.issuePassword(new IssuePasswordCommand({userId: this.userId, password: this.password})).subscribe({
            next: () => {
                notify({message: 'Password issued', position: 'bottom center'}, 'success', 3000);
                this.onVisibleChange(false);
            },
            error: (errors: unknown) => {
                this.isSaving = false;
                const messages = Array.isArray(errors) ? errors.map(error => error.message) : ['Failed to issue the password'];
                messages.forEach(message => notify({
                    message,
                    type: 'error',
                    displayTime: 5000,
                }, {
                    position: 'bottom right',
                    direction: 'up-push'
                }));
            }
        });
    }
}
